import { useState, useEffect, useMemo } from "react";

let hasAnimated = false;

export default function TextAnimator({
  text,
  delay = 500,
  className = "",
  renderWord,
}) {
  // Split text into words.
  const words = useMemo(() => text.split(" ").filter(Boolean), [text]);
  const [displayedWords, setDisplayedWords] = useState(
    hasAnimated ? words : []
  );

  useEffect(() => {
    if (hasAnimated) return;

    let index = 0;
    const interval = setInterval(() => {
      if (index < words.length - 1) {
        setDisplayedWords((prev) => [...prev, words[index]]);
        index++;
      } else {
        clearInterval(interval);
        hasAnimated = true;
      }
    }, delay);

    return () => clearInterval(interval);
  }, [delay, words]);

  return (
    <span className={className}>
      {displayedWords.map((word, i) =>
        renderWord ? renderWord(word, i) : word + " "
      )}
    </span>
  );
}
